import { WaterSortAudioId } from '../audio/audioEvents';
import { FEATURE_FLAG_KEYS } from '../constants/feature-flags';
import { WATERSORT_VERSION } from '../constants/version';
/**
 * Water Sort has NO music track (WP-37.6).
 *
 * `'watersort_bg_music'` used to be declared here and nowhere else — no entry
 * in `WaterSortAudioId`, no call site, and, as WP-37.6's asset-coverage guard
 * pointed out, no file in `public/audio` either. Module 37's locked decision 6
 * puts background music in Block Jam only, so the declaration was promising an
 * asset that was never going to arrive.
 *
 * The list stays (rather than the field being dropped) because `audioManifest`
 * requires both halves and because this is where a track would go if Water Sort
 * ever gets one.
 */
const AUDIO_TRACKS = [];
/**
 * Derived from the id enum, not hand-listed (WP-37.4).
 *
 * The hand-written list had silently fallen three ids behind: `pour_loop`
 * (WP-REF.8) and `tube_pickup` / `tube_place` (WP-POUR.9) were added to the
 * enum and played by the renderer, but never registered here. Nothing broke
 * while the manifest was only used for asset preloading — but from WP-37.2 it
 * also decides which channel an id plays on, so an unregistered id falls back
 * to SFX and an unregistered TRACK would ignore the music slider entirely.
 *
 * Deriving the list makes that drift impossible.
 */
const AUDIO_SFX = Object.values(WaterSortAudioId).filter((id) => !AUDIO_TRACKS.includes(id));
export function createWaterSortManifest(isEnabled = false) {
    return {
        gameId: 'watersort',
        version: WATERSORT_VERSION,
        factory: async () => {
            const mod = await import('./WaterSortPlugin');
            return { default: mod.WaterSortPlugin };
        },
        audioManifest: {
            tracks: [...AUDIO_TRACKS],
            sfx: [...AUDIO_SFX],
        },
        metadata: {
            gameId: 'watersort',
            displayName: 'Water Sort',
            shortDescription: 'Sort coloured liquids into tubes',
            thumbnailKey: 'AssetRegistry.WaterSort.Thumbnail',
            bannerKey: 'AssetRegistry.WaterSort.Banner',
            tags: ['puzzle', 'sorting', 'casual'],
            difficultyRating: 2,
            estimatedSessionMinutes: 5,
            minimumAgeRating: 4,
            supportedLanguages: ['en', 'hi'],
            featureFlags: {
                isEnabled,
                isComingSoon: false,
                isLocked: false,
            },
        },
    };
}
export const WATERSORT_FEATURE_FLAG = FEATURE_FLAG_KEYS.WATERSORT_ENABLED;
